import { createSlice } from '@reduxjs/toolkit'

// general imports
import { LocalStorageService } from '../../../services/storage/local-storage.service'
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { PhoneNumberType, getPhoneNumbersThunk } from '../thunks/phone-number.thunk'

export type PhoneNumberState = {
  requestResponse: ApiRequestDataType<PhoneNumberType[]>
}

export const initialState: PhoneNumberState = {
  requestResponse: {
    status:
      LocalStorageService.getStoredPhoneCodes() !== null &&
      LocalStorageService.getStoredPhoneCodes() !== undefined
        ? ApiRequestStatus.FULFILLED
        : ApiRequestStatus.IDLE,
    data: LocalStorageService.getStoredPhoneCodes(),
  },
}

const phoneNumberSlice = createSlice({
  name: 'phoneNumberSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPhoneNumbersThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
      })
      .addCase(getPhoneNumbersThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.requestResponse.data = action.payload

        LocalStorageService.storePhoneCodes(action.payload)
      })
      .addCase(getPhoneNumbersThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as unknown as StoredErrorResponseType
      })
  },
})

export default phoneNumberSlice.reducer
